// extracted by mini-css-extract-plugin
export var barContainer = "_4f-0";
export var extraThin = "_4f-3";
export var fillBar = "_4f-6";
export var fillContainer = "_4f-4";
export var overflow = "_4f-8";
export var overflowContainer = "_4f-5";
export var regular = "_4f-7";
export var thick = "_4f-1";
export var thin = "_4f-2";